import { graphql } from "babel-plugin-relay/macro";

export const CHANGE_EMAIL_MUTATION = graphql`
	mutation changeEmailDialog_ChangeEmailMutation($input: UpdateEmailInput!) {
		InfectopharmAuth {
			updateEmail(input: $input) {
				clientMutationId
			}
		}
	}
`;
